import { MFA_STEP_UP_PASSWORD_CHALLENGE, MFA_STEP_UP_CODE_CHALLENGE, MFA_STEP_UP_SUCCESS } from '../../constants/analytics-events';
import { Segment } from '../../services/analytics-services/segment';

/**
 * @typedef {'v1-api-key-create' | 'v2-api-key-create' | 'v1-api-key-delete' | 'v2-api-key-delete' | 'mfa-settings'} FeatureNames
 */

/**
 * @type {Record<string, FeatureNames>}
 */
export const USER_ACTIONS = {
  V1_API_KEY_CREATE: 'v1-api-key-create',
  V1_API_KEY_DELETE: 'v1-api-key-delete',
  V2_API_KEY_CREATE: 'v2-api-key-create',
  V2_API_KEY_DELETE: 'v2-api-key-delete',
  MFA_SETTINGS: 'mfa-settings',
};

/**
 * @typedef {object} TrackingParams
 * @property {string} source - request url mfa required error was received or feature name
 */

/**
 * @param {TrackingParams} params
 */
export const trackPasswordChallenge = (params) => {
  Segment.trackEvent(MFA_STEP_UP_PASSWORD_CHALLENGE, params);
};

/**
 * @param {TrackingParams} params
 */
export const trackCodeChallenge = (params) => {
  Segment.trackEvent(MFA_STEP_UP_CODE_CHALLENGE, params);
};

/**
 * @param {TrackingParams} params
 */
export const trackSuccess = (params) => {
  Segment.trackEvent(MFA_STEP_UP_SUCCESS, params);
};
